import { type } from "os";
import { axiosClient } from "../client";

const queryString = require("query-string");

const LOGS_INFO_GET_ALL = (locationId, orderId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_LOGS}/location/${locationId}/getLogsData/${orderId}`;

const LOGS_INFO_GET_ALL_DETAILS = (locationId, type) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_LOGS}/location/${locationId}/getLogsDetails/${type}`;

export const fetchAllVGetLogsInfo = (locationId, orderId) =>
  axiosClient({
    method: "GET",
    url: LOGS_INFO_GET_ALL(locationId, orderId),
    // params: filter,
  });

export const fetchAllLogsInfo = (locationId, type) =>
  axiosClient({
    method: "GET",
    url: LOGS_INFO_GET_ALL_DETAILS(locationId, type),
  });
